const { ccclass } = cc._decorator;

@ccclass
export default class Debug {
    private static _ccLog
    private static _ccWarn
    private static _ccError

    static _logOpen: boolean = false


    static get logOpen() {
        return this._logOpen
    }

    static set logOpen(value) {
        this._logOpen = value;
        if (value) {
            if (CC_DEBUG) {
                cc.log = this._ccLog
                cc.warn = this._ccWarn
                cc.error = this._ccError
            } else {
                cc.log = console.log
                cc.warn = console.warn
                cc.error = console.error
            }
        } else {
            cc.log = function() {}
            cc.warn = function() {}
            cc.error = function() {}
        }
    }

    static init() {
        this._ccLog = cc.log
        this._ccWarn = cc.warn
        this._ccError = cc.error
        this.logOpen = true
    }

    static getLogStr(values?: any[]) {
        let result = Date.now() + ": "
        if (values) {
            let length = values.length
            for (let i = 0; i < length; i++) {
                if (values[i]) {
                    if (typeof (values[i]) == "object") {//如果是对象
                        result = result + " " + i + ": " + JSON.stringify(values[i])
                    } else {
                        result = result + " " + i + ": " + values[i].toString()
                    }
                } else {
                    result = result + ": null "
                }
            }
        } else {
            result = result + ": null "
        }
        return result
    }
}